<!--约场地退款-->
<template lang="pug">
    d2-container
      el-form(:inline='true', :model='dataForm'  size='mini' label-position='right' label-width='75px' label-suffix=':')
        el-row(:span='24')
          el-col(:md='6' :sm='8')
             el-form-item(label='账号')
                el-input.inputWidth(v-model='dataForm.account', placeholder='账号', clearable='')
          el-col(:md='6' :sm='8')
             el-form-item(label='姓名' label-position='right')
                el-input.inputWidth(v-model='dataForm.name', placeholder='姓名', clearable='')
          el-col(:md='6' :sm='8')
              el-form-item(label='申请时间')
                 el-date-picker(style='width:210px', v-model='dataForm.rangeTime' range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd")
        el-row(:span='24')
          el-col(:span="12" style="padding-bottom: 15px;")
            el-button(@click="exportExcel()" type="primary") 导出报表
          el-col(:span='12' style="padding-bottom:15px;float:right")
            el-button(@click="getDataList('query')",type='primary',icon='el-icon-search' style='float:right;') 查 询
        el-table(:data="tableData" style="width: 100%" v-loading='dataListLoading' border)
            el-table-column(prop='name' header-align='center',align='center',label='姓名'  )
            el-table-column(prop='accout' header-align='center',align='center',label='账号')
            el-table-column(header-align='center',align='center',label='场地名称')
              template(slot-scope="scope")
               font {{ scope.row.placeMode.name }}
            el-table-column(header-align='center',align='center',label='场地ID')
              template(slot-scope="scope")
               font {{ scope.row.placeMode.id }}
            el-table-column(header-align='center',align='center',label='场地属性')
              template(slot-scope="scope")
               font {{ scope.row.placeMode.type }}
            el-table-column(header-align='center',align='center',label='场地号')
              template(slot-scope="scope")
               font {{ scope.row.placeMode.fieldNo }}
            el-table-column(header-align='center',align='center',label='日期')
              template(slot-scope="scope")
               font {{ scope.row.placeMode.day }}
            el-table-column(header-align='center',align='center',label='时间段')
              template(slot-scope="scope")
               font {{ scope.row.placeMode.startTime }} ~ {{ scope.row.placeMode.endTime }}
            el-table-column(header-align='center',align='center',label='申请时间' width="160px")
              template(slot-scope="scope")
               font {{ scope.row.applyTime.split('T').join(' ') }}
            el-table-column(prop='payAmount' header-align='center',align='center',label='支付金额')
              template(slot-scope="scope" v-if="scope.row.payAmount")
                font ￥{{ parseFloat(scope.row.payAmount).toFixed(2) }}元
            el-table-column(prop='refundProportion' header-align='center',align='center',label='退款比例')
              template(slot-scope="scope" v-if="scope.row.refundProportion")
                font {{ scope.row.refundProportion }}%
            el-table-column(header-align='center',align='center',label='退款金额')
              template(slot-scope="scope" v-if="scope.row.refundMoney")
                font ￥{{ parseFloat(scope.row.refundMoney).toFixed(2) }}元
            el-table-column(prop='statusName' header-align='center',align='center',label='状态')
            el-table-column(prop="refundDesc" header-align="center",align="center",label="退款原因")
              template(slot-scope="scope")
                span() {{ refundDesc_Com(scope.row.refundDesc) }}
        el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
</template>
<script>
import table from './table.js'
import { get30DaysArray } from '@/util/dateUtils'

export default {
  name: 'finance-competitionOrder-reserveSiteRefund',
  data () {
    return {
      // 导出报表
      table: {
        columns: table.columns,
        data: null,
        size: 'mini',
        stripe: true,
        border: true
      },
      isCollapse: true,
      detailVisiable: false,
      dataForm: { account: '', // 查询参数
          appyBegin: '',
          appyEnd: '',
          name: '',
          rangeTime: []
      },
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false
    }
  },
  computed: {
    // 退款原因截取前30个字符
    refundDesc_Com () {
      return function (str) {
        if (str) {
          if (str.length > 30) {
            return `${str.slice(0, 30)}...`
          } else {
            return str
          }
        } else {
          return '-'
        }
      }
    }
  },
  mounted () {
    this.dataForm.rangeTime = get30DaysArray()
    this.getDataList()
  },
  methods: {
    // 获取数据列表
    getDataList (type) {
      if (type) {
        this.pageIndex = 1
      }
      this.dataListLoading = true
      let [ startTime = null, endTime = null ] = this.dataForm.rangeTime || []
      this.dataForm.appyBegin = startTime
      this.dataForm.appyEnd = endTime
      this.$http({
        url: this.$http.adornUrl('/payRefund/refund-list'),
        method: 'POST',
        params: this.$http.adornParams({
          page: this.pageIndex,
          limit: this.pageSize
        }),
        data: this.dataForm
      }).then(data => {
        if (data && data.code === 0) {
          this.tableData = data.data.rows
          this.totalPage = data.data.total
        } else {
          this.tableData = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    confirmRefund (id) {
      console.log('确认退款', id)
      this.$http({
        url: this.$http.adornUrl('/payRefund/confirmRefund'),
        method: 'post',
        params: this.$http.adornParams({
          id: id
        })
      }).then(data => {
        if (data.code === 0) {
          this.$message.success('退款成功!')
          this.getDataList()
        } else {
          this.$message.success('退款失败!')
        }
      })
    },
    returnApply (id) {
      console.log('退回申请', id)
      this.$http({
        url: this.$http.adornUrl('/payRefund/returnApply'),
        method: 'post',
        params: this.$http.adornParams({
          id: id
        })
      }).then(data => {
        if (data.code === 0) {
          this.$message.success('退回申请成功!')
          this.getDataList()
        } else {
          this.$message.success('退回申请失败!')
        }
      })
    },
    //导出报表
    exportExcel () {
      let [ startTime = null, endTime = null ] = this.dataForm.rangeTime || []
      this.dataForm.appyBegin = startTime
      this.dataForm.appyEnd = endTime
      this.$http({
        url: this.$http.adornUrl('/payRefund/refund-list'),
        method: 'POST',
        params: this.$http.adornParams({
          page: 1,
          limit: 100000
        }),
        data: this.dataForm
      }).then(data => {
        if (data && data.code === 0) {
          // 为空判断
          if (data.data.rows == null || data.data.rows.length === 0) {
            this.$message.info('没有要导出的数据!')
            return
          }

          // 数据转化
          let exportData = data.data.rows
          for (let i of exportData) {
            i.__name__ = i.placeMode.name
            i.__id__ = i.placeMode.id
            i.__type__ = i.placeMode.type
            i.__fieldNo__ = i.placeMode.fieldNo
            i.__day__ = i.placeMode.day
            i.__time__ = `${i.placeMode.startTime} ~ ${i.placeMode.endTime}`
          }

          // 导出表格
          this.$export.excel({
            columns: this.table.columns,
            data: exportData,
            title: '约场地退款报表'
          }).then(() => {
            this.$message.success('约场地退款报表导出成功')
          })
        }
      })
    }
  }
}
</script>
<style>
.inputWidth {
  width: 210px;

}
.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 0px;
  vertical-align: top;
}
</style>
<style >
  /* 操作三点 菜单样式 */
 @import '../../../css/opr3dot.css';

</style>
